
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard",
      function () {
        return require("private-next-pages/dashboard.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard"])
      });
    }
  